<!DOCTYPE html>
<html lang="en">

<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.3/dist/css/bootstrap.min.css" rel="stylesheet" crossorigin="anonymous">
    <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/flag-icons/3.6.6/css/flag-icons.min.css">
    <link href="https://cdn.lineicons.com/4.0/lineicons.css" rel="stylesheet">
    <link href='https://fonts.googleapis.com/css?family=Montserrat' rel='stylesheet'>
    <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.4/css/all.min.css">



</head>

<body>





    <div class="wrapper">

        <!-- Mobile Backdrop Overlay -->
        <div class="sidebar-backdrop" 
             [ngClass]="{'show': isMobileSidebarOpen}" 
             (click)="sidebarService.closeMobileSidebar()"
             *ngIf="isMobileSidebarOpen"></div>

        <!-- side -->
        <aside id="sidebar" [ngClass]="{'expand': isSidebarExpanded, 'mobile-open': isMobileSidebarOpen}">
            <!-- Logo Section -->
            <div class="sidebar-logo-section">
                <div class="qnbn-logo">
                    <img src="assets/img/bidaya-square.png" alt="Bidaya Home Finance" class="qnbn-logo-image" *ngIf="isSidebarExpanded">
                    <img src="assets/img/bidaya-square.png" alt="Bidaya Home Finance" class="qnbn-logo-image-collapsed" *ngIf="!isSidebarExpanded">
                </div>
            </div>
              
              <!-- Expand/Collapse Button with Bootstrap Icons -->
              <div class="close-button">
                <button id="expand-collapse-btn" type="button" (click)="toggleSidebar()" class="btn icon-btn">
                  <i [ngClass]="isSidebarExpanded ? 'bi bi-arrow-bar-left' : 'bi bi-arrow-bar-right'" class="fs-3"></i>
                </button>
              </div>
              





            <ul class="sidebar-nav">
                <li *ngFor="let item of sidebarItems" class="sidebar-item">
                    <a class="sidebar-link" [routerLink]="item.route" [ngClass]="{'logout-item': item.label === 'logout', 'active-sidebar-link': isActiveRoute(item.route)}" (click)="handleButtonClick($event, item.label); onSidebarLinkClick()" data-toggle="tooltip" title="{{ item.label }}">
                        <img [src]="'assets/icons/' + item.icon + '.png'" width="24" height="24" alt="icon" class="sidebar-icon">
                        <span class="sidebar-label" *ngIf="isSidebarExpanded">{{ item.label }}</span>
                    </a>
                </li>
            </ul>
        </aside>

        <div #dragAndDropArea id="drag-and-drop-area">
            <!-- Drag and drop area content -->
        </div>
        <input #documentUploadInput type="file" id="document-upload-input" hidden>



        <div class="main">

            <!-- Header -->
            <app-header></app-header>
            <!-- body -->
            <router-outlet></router-outlet>

            <app-chat-popup>
            </app-chat-popup>

            <app-dialog>
            </app-dialog>


        </div>


    </div>






</body>

</html>
